import React from 'react';
import { styled } from 'styled-components';
const Warning = (props) => {
    return (React.createElement(WarningStyled, { style: props.style }, props.messages.map((m) => (React.createElement("div", { className: "warning" }, m)))));
};
export default Warning;
const WarningStyled = styled.div `
  .warning {
    border-radius: 3px;
    background-color: #fff3cd;
    padding: 12px 15px;
    font-size: 0.8em;
    margin-bottom: 20px;
    width: 100%;
    background-image: none;
    border: 1px solid #ffe69c;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    color: #664d03;
  }
`;
//# sourceMappingURL=Warning.js.map